'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useMemo } from 'react';

const StorePreviousUrl = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const searchParamsString = useMemo(
    () => (searchParams.toString() ? '?' + searchParams.toString() : ''),
    [searchParams]
  );

  useEffect(() => {
    const currentUrl = pathname + searchParamsString;

    localStorage.setItem('previousUrl', currentUrl);
  }, [pathname, searchParamsString]);

  return null;
};

export default StorePreviousUrl;
